import React from "react";
import PropTypes from "prop-types";
import "./DispatchVisibilityTable.css";

const DispatchPriorityGlobalVisibilityTable = ({ data = [], orderLossType }) => {

  /* ✅ K / L / Cr FORMATTER */
  const formatToCappedUnit = (value) => {
    if (value === null || value === undefined) return "-";
    if (value < 1000) {
      return `${value}`;
    }
    if (value < 100000) {
      return `${(value / 1000).toFixed(1)} K`;
    }

    if (value < 10000000) {
      return `${(value / 100000).toFixed(1)} L`;
    }

    return `${(value / 10000000).toFixed(1)} Cr`;
  };

  return (
    <div className="tableWrapper">
      <table className="visibilityTable">
        <thead>
          <tr>
            <th>Lane</th>
            <th>No of CLDs Shipment</th>
            <th>Truck Loading Delay (Hrs)</th>
            <th>Sending Plant</th>
            <th>Receiving Plant</th>
            <th>Total Stock Value</th>
            <th>Total {orderLossType} mitigated</th>
            <th>Total shipments</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={8} style={{ textAlign: "center", padding: "16px" }}>
                No data available
              </td>
            </tr>
          ) : (
            data.map((row) => (
              <tr key={`${row["Lane"]}-${row["Sending Plant"]}-${row["Receiving Plant"]}-${row["No of CLDs Shipment"]}`}>
                <td>{row["Lane"]}</td>

                <td>{row["No of CLDs Shipment"]}</td>

                <td>
                  {row["Truck Loading Delay (Hrs)"]}
                </td>

                <td>{row["Sending Plant"]}</td>

                <td>{row["Receiving Plant"]}</td>

                {/* ✅ Total Stock Value (formatted) */}
                <td
                  title={row["Total Stock Value of Material in Shipment"]}
                >
                  {formatToCappedUnit(
                    row["Total Stock Value of Material in Shipment"]
                  )}
                </td>

                {/* ✅ Total Mitigated Value (formatted) */}
                <td
                  title={row[`Total Value of ${orderLossType} mitigated`]}
                >
                  {formatToCappedUnit(
                    row[`Total Value of ${orderLossType} mitigated`]
                  )}
                </td>

                <td>{row["Total number of shipments"]}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

DispatchPriorityGlobalVisibilityTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  orderLossType: PropTypes.string,
};

export default DispatchPriorityGlobalVisibilityTable;